module.exports = __webpack_public_path__ + "img/img-5.c91e4cee.png";